import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { APIConstants, CommonAPIConstants, PatientTrackerConstants } from '../utilities/Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf, faTrashCan, faFile } from '@fortawesome/free-regular-svg-icons'
import { useSelector } from 'react-redux';




const EncounterTrackerTable = ({ columns, data, handleGetPatientTrackerDetailedData, handleGetUserAudits }) => {


    const [activeRow, setActiveRow] = useState(null);
    const [searchByName, setSearchByName] = useState("");

    const [searchQuery, setSearchQuery] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, ascending: true });
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const userData = useSelector((state) => state.user.user);
    console.log('userData:', userData);




    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;





    // Filter data based on search query
    const filteredData = data?.filter((item) =>
        item.ProviderName.toLowerCase().includes(searchQuery.toLowerCase())
    );









    const handleSort = (key) => {
        setSortConfig((prev) => ({
            key,
            ascending: prev.key === key ? !prev.ascending : true,
        }));
    };

    // Sorting logic
    const sortedData = [...filteredData].sort((a, b) => {
        if (!sortConfig.key) return 0;

        const valA = a[sortConfig.key] || "";
        const valB = b[sortConfig.key] || "";

        if (typeof valA === "number" && typeof valB === "number") {
            return sortConfig.ascending ? valA - valB : valB - valA;
        } else {
            return sortConfig.ascending
                ? valA.toString().localeCompare(valB.toString())
                : valB.toString().localeCompare(valA.toString());
        }
    });



    const handleRowClick = (index) => {
        setActiveRow(index);
    };






    const handleOpenModal = (item, countType) => {
        setSelectedItem(item, countType);
        handleGetPatientTrackerDetailedData(item, countType);
        setIsModalOpen(true);
    };





    return (



        <table  className="table table-bordered table-hover table-primary">
            <thead>
                <tr className='align-top'>

                    <>
                        {columns.map((col, index) => (
                            <th key={index} className="col-th text-white"
                                style={{

                                    backgroundColor:
                                        col.accessor === "CPTCount"
                                            ? "lightpink"
                                            : col.accessor === "UnitCount"
                                                ? "#d7d469"
                                                : "#0173b7",
                                    width: col.accessor === "index" ? "50px" : "auto",
                                    width: col.accessor === "UnsignedEnc" ? "190px" : "auto",


                                }}>
                                {col.accessor === "index" ? (
                                    <label>{col.header}</label>
                                ) : (
                                    <Link
                                        to="#"
                                        style={{ color: "white" }}
                                        onClick={() => handleSort(col.accessor)}
                                    >
                                        {col.header}
                                    </Link>
                                )}




                                {col.accessor === "ProviderName" && (
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{
                                            width: "120px",
                                            borderRadius: "5px",
                                            marginTop: "5px",
                                            display: "block",
                                        }}
                                    />
                                )}


                            </th>
                        ))}
                    </>

                </tr>
            </thead>
            <tbody>
                {sortedData.length > 0 ? (
                    sortedData.map((row, rowIndex) => (
                        <tr
                            className={`${activeRow === rowIndex ? "table-warning" : ""} table-primary`}
                           
                            key={rowIndex}
                            onClick={() => handleRowClick(rowIndex)}
                        >


                            {columns.map((col, colIndex) => (
                                <td key={colIndex}  
                                    style={{
                                        backgroundColor:
                                          col.accessor === "CPTCount"
                                            ? "lightpink"
                                            : col.accessor === "UnitCount"
                                            ? "#d7d469"
                                            : "",  
                                      
    
                                }}>
                                    {col.accessor === "index" ? (
                                        <label style={{ width: '20px' }}>{rowIndex + 1}</label>
                                    ) :
                                        col.accessor === "ProviderName" ? (
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                <span>{row.ProviderName || "-"}</span>
                                                <FontAwesomeIcon style={{ marginLeft: "8px", color: "#000"}} className='pdf-icon' onClick={() => handleGetUserAudits(row)} icon={faFile} />
                                            </div>
                                        ) : col.accessor === "totalEncounters" ? (
                                            <Link
                                                style={{ color: "black", cursor: "pointer" }}
                                                onClick={() => handleOpenModal(row, 3)}
                                            >
                                                {(Number(row.SignedEnc) || 0) + (Number(row.UnsignedEnc) || 0)}
                                            </Link>
                                        ) : col.accessor === "CPTCount" || col.accessor === "UnitCount" || col.accessor === "ProviderName" ? (
                                            row[col.accessor] || "-"
                                        ) : col.accessor === "nonduplicatePatcount" ? (
                                            <Link
                                                style={{ color: "black", cursor: "pointer" }}
                                                onClick={() => handleOpenModal(row, 2)}
                                            >
                                                {row[col.accessor] || "-"}
                                            </Link>
                                        ) : col.accessor === "SignedEnc" ? (
                                            <Link
                                                style={{ color: "black", cursor: "pointer" }}
                                                onClick={() => handleOpenModal(row, 1)}
                                            >
                                                {row[col.accessor] || "-"}
                                            </Link>
                                        ) : col.accessor === "UnsignedEnc" ? (
                                            <Link
                                                style={{ color: "black", cursor: "pointer" }}
                                                onClick={() => handleOpenModal(row, 0)}
                                            >
                                                {row[col.accessor] || "-"}
                                            </Link>
                                        ) : (
                                            <Link
                                                style={{ color: "black" }}
                                                onClick={() => handleOpenModal(row, 3)}
                                            >
                                                {row[col.accessor] || "-"}
                                            </Link>
                                        )}
                                </td>
                            ))}

                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={columns.length} className="text-center">
                            No Data Available
                        </td>
                    </tr>
                )}
            </tbody>

            <tfoot>
                <tr className="table-secondary">
                    {columns.map((col, colIndex) => (
                        <td key={colIndex} style={{ fontWeight: "bold" }}>
                            {col.accessor === "index"
                                ? "Total"
                                : col.accessor === "ProviderName"
                                    ? ""
                                    : col.accessor === "totalEncounters"
                                        ? filteredData.reduce(
                                            (sum, row) => sum + (Number(row.SignedEnc) || 0) + (Number(row.UnsignedEnc) || 0),
                                            0
                                        )
                                        : ["CPTCount", "UnitCount", "nonduplicatePatcount", "SignedEnc", "UnsignedEnc"].includes(col.accessor)
                                            ? filteredData.reduce((sum, row) => sum + (Number(row[col.accessor]) || 0), 0)
                                            : "0"}
                        </td>
                    ))}
                </tr>
            </tfoot>


        </table>




    );
};

export default EncounterTrackerTable;
